<template>
  <div>
    <back-button class="breadcrumb-item-padding" />
    <b-breadcrumb
      :items="items"
      class="d-inline-flex breadcrumb-item-padding breadcrumb-background-color"
    />
  </div>
</template>

<script>
import BackButton from './BackButton';
import {createNamespacedHelpers} from 'vuex';

const {mapState: sidebarMapState} = createNamespacedHelpers('sidebar');
export default {
  name: 'Breadcrumb',
  components: {BackButton},
  data() {
    return {
      items: [],
    };
  },
  watch: {
    menuItems: {
      handler(val) {
        this.menuItemsWatchHandler(val);
      },
      immediate: true,
    },
    selectedFolderGuid:{
      handler(){
        this.menuItemsWatchHandler(this.menuItems);
      },
      immediate: true,
    },
  },
  computed: {
    ...sidebarMapState({
      menuItems: state => state.menuItems,
      selectedFolderGuid: state => state.selectedFolder,
    }),
    isEditMode() {
      return this.$route.fullPath.includes('builder');
    },
  },
  methods: {
    resetBreadCrumbs() {
      this.items =  [];
    },
    menuItemsWatchHandler(val){
      if (!val) return;
      this.resetBreadCrumbs();
      const moduleUuid = this.$route.params.moduleGuid || this.$route.params.moduleUuid;
      const tableUuid = this.$route.params.tableUuid || this.$route.params.tableId;
      const folderUuid = this.$route.query.folderUuid;

      const module = val.find(el => el.moduleGuid === moduleUuid);
      this.items.push(this.generateBreadcrumbItem(module.label,  moduleUuid) );
      if (module && module.children.length ) {
        let folder;
        if(tableUuid || folderUuid) {
          folder = module.children.find(el => (
            el.folderGuid === this.selectedFolderGuid
                || el.folderGuid === localStorage.getItem('folder')
                || el.folderGuid === folderUuid
                || el.children?.some(child => child.entityGuid === tableUuid)
          ));
          folder && this.items.push(this.generateBreadcrumbItem(folder.label,  moduleUuid));
        }

        if (folderUuid) {
          this.items.push('Create New table');
        }
        if (folder && folder.children.length) {
          const table = folder.children.find(el => el.entityGuid === tableUuid);
          table && this.items.push(this.isEditMode ? `Update table "${table.label}"` : table.label);
        }
      }
    },
    generateBreadcrumbItem(label,  uuid) {
      // if it is loan calculator module navigate to loan calculator page, as it is custom page
      const to = uuid == '37f9e5ae-a0ab-425f-a8ea-b40f5eb79f7f' ? { name: 'loanCalculator'} : {name: 'dataManagementModuleView', params: {moduleUuid: uuid}};
      return {
        text: label,
        to: to,
      };
    },
  },
};
</script>

<style scoped>
.breadcrumb-item-padding {
  padding: 0.25rem 0.5rem;
  margin-bottom: 0
}

.breadcrumb-background-color {
  background-color: white;
}

</style>